module.exports = __webpack_public_path__ + "img/step-1.c94692c5.svg";